import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Role, RoleGroup } from '../../auth/roles';
import { AppLoadingComponent } from '../loading-page/app-loading.component';
import { TopSectionComponent } from '../navigation/components/top-section/top-section.component';
import { useAuthorization } from './authorization.composable';
import { UnauthorizedPage } from './unauthorized.page';

@Component({
  selector: 'cdf-authorization-wrapper',
  imports: [UnauthorizedPage, AppLoadingComponent, TopSectionComponent],
  template: `
    @if (authorization.loading()) {
      <cdf-top-section>
        <cdf-app-loading />
      </cdf-top-section>
    } @else if (authorization.authorized()) {
      <ng-content />
    } @else {
      <cdf-unauthorized-page [allowedRoles]="allowedRoles()" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthorizationWrapper {
  /**
   * The roles that are allowed to access this content.
   *
   * This defaults to all roles in the CDF role group.
   */
  readonly allowedRoles = input<readonly Role[]>(RoleGroup.CDF);

  readonly skipWhitelistCheck = input(false, { transform: booleanAttribute });

  protected readonly authorization = useAuthorization({
    allowedRoles: this.allowedRoles,
    skipWhitelistCheck: this.skipWhitelistCheck,
  });
}
